export const TYPES = {
  analyticsCollector: {
    AnalyticsCollector: "AnalyticsCollector",
    GoogleAnalyticsSender: "GoogleAnalyticsSender",
    VintomAnalyticsSender: "VintomAnalyticsSender"
  },
  animationPersonalizer: {
    AnimationPersonalizer: "AnimationPersonalizer"
  },
  configurationBuilder: {
    ConfigurationBuilder: "ConfigurationBuilder"
  },
  iframeNotifier: {
    IframeNotifier: "IframeNotifier"
  },
  layer: {
    PlayerContainer: "PlayerContainer",
    AnimationLayer: "AnimationLayer",
    ControlsLayer: "ControlsLayer",
    CTALayer: "CTALayer",
    PosterLayer: "PosterLayer",
    VideoLayer: "VideoLayer",
    MusicLayer: "MusicLayer"
  },
  loader: {
    playerLoader: {
      PlayerLoader: "PlayerLoader"
    },
    resourceLoader: {
      ResourceLoader: "ResourceLoader"
    },
    scenarioLoader: {
      ScenarioLoader: "ScenarioLoader"
    }
  },
  personalizer: {
    Personalizer: "Personalizer"
  },
  preferencesStorage: {
    PreferencesStorage: "PreferencesStorage"
  },
  errorReporter: {
    ErrorReporter: "ErrorReporter"
  },
  scenarioRunner: {
    layerManager: {
      PlayerContainerManager: "PlayerContainerManager",
      ControlsLayerManager: "ControlsLayerManager",
      CTALayerManager: "CTALayerManager",
      DependentAnimationLayerManager: "DependentAnimationLayerManager",
      IndependentAnimationLayerManager: "IndependentAnimationLayerManager",
      PosterLayerManager: "PosterLayerManager",
      VideoLayerManager: "VideoLayerManager",
      MusicLayerManager: "MusicLayerManager"
    },
    musicManager: {
      MusicManager: "MusicManager"
    },
    AnimationDrivenScenarioExecutor: "AnimationDrivenScenarioExecutor",
    CTAOnlyScenarioExecutor: "CTAOnlyScenarioExecutor",
    ScenarioRunner: "ScenarioRunner",
    VideoDrivenScenarioExecutor: "VideoDrivenScenarioExecutor"
  },
  themeUpdater: {
    ThemeUpdater: "ThemeUpadater"
  },
  PlayerManager: "PlayerManager"
};
